// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbd7e2f9","453":"6ef57c85","455":"087c6aac","977":"8c6c1a52"}[chunkId] + ".chunk.js";
};